import(/* webpackMode: "eager" */ "/var/www/next-frontend/src/app/(home)/layout.js");
